import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/wow-polo-logo.webp")